import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsDefined,
  IsIn,
  IsInt,
  IsOptional,
  IsString,
  Max,
  MaxLength,
  Min,
  ValidateIf,
} from 'class-validator';
import { DEADLINE_ASSIGNEE_ID_MAX_LENGTH, MAX_RENEWAL_VALIDITY_MONTHS } from './deadline.constants';
import { DEADLINE_RENEWAL_KINDS, type DeadlineRenewalKind } from './deadline-management.constants';
import { IsIsoDay } from './is-iso-day.decorator';

/**
 * Valori del form di rinnovo (client). Il tipo di rinnovo lo decide la riga (ricorrente o unica),
 * non l'utente; il file viaggia nel multipart e non nel body JSON.
 */
export class RenewDeadlineFormDto {
  @IsIn(DEADLINE_RENEWAL_KINDS)
  renewalKind!: DeadlineRenewalKind;

  @ValidateIf((form: RenewDeadlineFormDto) => form.renewalKind === 'RECURRING')
  @IsIsoDay()
  issuedAt?: string;

  @ValidateIf(
    (form: RenewDeadlineFormDto) => form.renewalKind === 'ONE_OFF' && form.dueAtRequired !== false,
  )
  @IsIsoDay()
  dueAt?: string;

  /** Falso per una riga "Nessuna scadenza": si carica solo il file e la riga resta senza data. */
  @IsOptional()
  @IsBoolean()
  dueAtRequired?: boolean;

  /** Solo per una unica: "da ora si rinnova ogni N mesi". */
  @IsBoolean()
  becomesRecurring!: boolean;

  @ValidateIf(
    (form: RenewDeadlineFormDto) => form.renewalKind === 'RECURRING' || form.becomesRecurring,
  )
  @IsDefined()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(MAX_RENEWAL_VALIDITY_MONTHS)
  validityMonths?: number;

  @IsDefined()
  file?: unknown;

  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_ASSIGNEE_ID_MAX_LENGTH)
  assigneeUserId?: string | null;

  /** Solo nel rinnovo del consulente che gestisce la riga: la firma richiesta per questo file. */
  @IsOptional()
  @IsBoolean()
  requestClientSignature?: boolean;
}
